import React from 'react';
import {ItemDetailsDataHook} from './ItemDetails';
import {Text} from '@wix/wix-ui-tpa/cssVars';
import {DetailLine} from './DetailLine';
import {useLocaleKeys} from '../../../../locale-keys/LocaleKeys';
import {classes} from './ItemOptions.st.css';

export const DetailsGroup = ({
  itemId,
  group,
}: {
  itemId: string;
  group: {descriptionLines: string[]; groupName?: string};
}) => {
  const localeKeys = useLocaleKeys();
  return (
    <>
      {group.groupName && (
        <Text data-hook={ItemDetailsDataHook.GroupName} className={classes.groupName}>
          {localeKeys.checkout.order_summary.items.modifiers.categoryLabel({categoryName: group.groupName})}
        </Text>
      )}
      <ul className={classes.options} data-hook={ItemDetailsDataHook.GroupOptionsList}>
        {group.descriptionLines?.map((descriptionLine) => (
          <li key={`${itemId}-${descriptionLine}`}>
            <DetailLine value={descriptionLine} />
          </li>
        ))}
      </ul>
    </>
  );
};
